export class PlayerQueueError extends Error {
    constructor(code, messages) {
        super(messages);
        /**
         * Sets the unrecoverable function to `true`.
         */
        this.unrecoverable = false;
        this.code = code;
        this.name = 'PlayerQueueError';
    }
}
//# sourceMappingURL=player_queue.js.map